"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackagePriceBandForDate = void 0;
const dayjs = require("dayjs");
const getPackagePriceBandForDate = (date, pkg) => {
    if (!date) {
        date = dayjs().toISOString();
    }
    if (!pkg)
        return;
    let room_prices = pkg?.room?.prices.find((price) => {
        return (dayjs(date).unix() >= dayjs(price.from_date).unix() &&
            dayjs(date).unix() <= dayjs(price.to_date).unix());
    });
    if (!room_prices) {
        room_prices = pkg?.room?.prices[0];
    }
    return room_prices;
};
exports.getPackagePriceBandForDate = getPackagePriceBandForDate;
